import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import InstitutionForm from './Components/InstitutionForm';
import LoginPageWrapper from '../Components/LoginPageWrapper';
import { useInstitutionErrorMessage, useLastSelectedInstitution } from './InstitutionHooks';

import '../Login.scss';

const spinnerId = 'InstitutionForm';

function Institution(props) {
  const { isAnonymousUser, errorMessage, cancel, notifications, init, isLoading, resetState } = props;
  const lastSelectedInstitution = useLastSelectedInstitution();
  const institutionErrorMessage = useInstitutionErrorMessage(errorMessage);

  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      // if named or institution with access to Reaxys
      cancel();
      return;
    }
    init();

    document.addEventListener('keyup', keyUpListener);

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('keyup', keyUpListener);

      resetState();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <LoginPageWrapper
      cancel={cancel}
      notifications={notifications}
      className="react-page-institution-page"
      mainAriaLabel="Institution screen">
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <InstitutionForm
        {...props}
        notifications={notifications}
        lastSelectedInstitution={lastSelectedInstitution}
        institutionErrorMessage={institutionErrorMessage}
      />
    </LoginPageWrapper>
  );
}

Institution.propTypes = {
  isAnonymousUser: PropTypes.bool,
  init: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  notifications: PropTypes.object,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  resetState: PropTypes.func,
};

export default Institution;
